import { getEnv } from '@jooxter/env';

const { COGNITO_USERPOOL_CLIENT_ID, COGNITO_USERPOOL_ID, COGNITO_DOMAIN } = getEnv();

if (!(COGNITO_DOMAIN && COGNITO_USERPOOL_CLIENT_ID && COGNITO_USERPOOL_ID)) {
  throw new Error('Missing environment variables for authentication', {
    cause: 'Some environment variables are missing, check secrets and CI',
  });
}

export const defaultAmplifyConfig = {
  Geo: {
    LocationService: {
      region: 'eu-west-1',
    },
  },
  Auth: {
    Cognito: {
      userPoolClientId: COGNITO_USERPOOL_CLIENT_ID,
      userPoolId: COGNITO_USERPOOL_ID,
      loginWith: {
        username: false,
        email: true,
        oauth: {
          domain: COGNITO_DOMAIN,
          scopes: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code' as const,
        },
      },
      signUpVerificationMethod: 'code' as const,
    },
  },
};
